<template>
  <div class="box box_books">
    <search-box class="detail_search"></search-box>
    <div class="content" ref="books">
      <!-- 侧边栏 -->
      <side class="left_side" v-on:putCategoryId="getCategoryId" :parents="parents"></side>
      <div class="right">
        <div class="nav">
          <span class="nav_book" v-if="pp_category_name"
            @click="pushside(1)">
            <img
              class="icon_nav"
              v-if="pp_category_name=='本土著述'"
              src="../../assets/public/ancientBooks/local_icon_nav_grey.png"
              alt="本土著述的小图标"
            />
            <img
              class="icon_nav"
              v-if="pp_category_name=='域外著述'"
              src="../../assets/public/ancientBooks/outside_icon_nav_grey.png"
              alt="域外著述的小图标"
            />
            {{pp_category_name}}
          </span>
          <span
            :class="[p_category_name&&!pp_category_name?'nav_middle_no':'nav_middle']"
            v-if="p_category_name"
            @click="pushside(2)"
          >
            <img
              class="icon_nav"
              v-if="p_category_name=='本土著述'"
              src="../../assets/public/ancientBooks/local_icon_nav_grey.png"
              alt="本土著述的小图标"
            />
            <img
              class="icon_nav"
              v-if="p_category_name=='域外著述'"
              src="../../assets/public/ancientBooks/outside_icon_nav_grey.png"
              alt="域外著述的小图标"
            />
            {{p_category_name}}
          </span>
          <span
            :class="[!pp_category_name&&!p_category_name?'nav_current_no':'nav_current']"
            v-if="category_name"
            @click="pushside(3)"
          >
            <img
              class="icon_nav_active"
              v-if="category_name=='本土著述'"
              src="../../assets/public/ancientBooks/local_icon_nav.png"
              alt="本土著述的小图标"
            />
            <img
              class="icon_nav_active"
              v-if="category_name=='域外著述'"
              src="../../assets/public/ancientBooks/outside_icon_nav@2x.png"
              alt="域外著述的小图标"
            />
            {{category_name}}
          </span>
        </div>
        <div class="lists" ref="lists">
          <div class="list" v-for="(item,index) in books" :key="index" :data-id="item.book_id">
            <!-- <div class="image_box" :style="{'background':bgcolor[parseInt(5*Math.random())]}" @click="toBookDetail(item.book_id)"> -->
            <router-link
              tag="a"
              :to="{path:'/bookDetail',query:{book_id:item.book_id}}"
              target="_blank"
              class="image_box"
              :style="{backgroundColor:item.background}"
            >
              <div class="book_box">
                <!-- <div class="book_box" @mouseenter="showBig(item.book_id)" @mouseleave="hideBig()"> -->
                <img height="" width="" v-if="item.cover" :src="item.cover" alt class="book" />
                <img v-else src="../../assets/public/ancientBooks/book.png" alt class="book" />
                <img src="../../assets/public/shadow_bg@2x.png" alt class="shadow" />
              </div>
              <transition name="slide-fade">
                <div class="scale_box" v-show="showId==item.book_id">
                  <img :src="item.cover" class="book_scale" />
                  <img src="../../assets/public/shadow_bg@2x.png" alt class="shadow_scale" />
                </div>
              </transition>
            </router-link>
            <!-- 书名 -->
            <p
              class="title"
            >{{item.name}}</p>
            <!-- 作者 -->
            <div class="author">{{item.author}}</div>
            <!-- 卷数 -->
            <!-- <div class="remark">{{item.volumes}}</div> -->
          </div>
        </div>
        <div class="pagination" v-if="total_pages>1">
          <el-pagination
            @prev-click="handlePre"
            @next-click="handleNext"
            @current-change="changePage"
            :current-page="current_page"
            background
            layout="prev, pager, next"
            :page-size="1"
            :total="total_pages"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import searchBox from "../public/searchBox.vue";
import Side from "../public/side.vue";
export default {
  data() {
    return {
      current_category_id: "",
      // 古籍页面内导航
      category_name: null,
      p_category_name: null,
      pp_category_name: null,
      books: null,
      current_page: 1,
      input_page: 1,
      page_size: 9,
      total_pages: null,
      bgcolor: ["#E2F9FF", "#FFE4E4", "#FFF6E4", "#F4F4F4", "#E4ECFF"],
      scroll: false,
      showId: null,
      parents:null,
      ancientArr:{}
    };
  },
  metaInfo: {
    title: "千年医典数据库-科学支撑中医临床、教学科研、健康养生",
    meta: [
      {
        name: "keywords",
        content: "朝代,清,明,元,宋,唐,日本,医经,基础理论,伤寒,诊法,本草,医史"
      },
      { name: "description", content: "千年医典数据库的中医古籍分类" }
    ]
  },
  components: {
    Side,
    searchBox
  },
  created() {
    const hashLocation = this.$route.path;
    //   const newLocation = hashLocation.split("#/")[1];
    const url = "https://www.kanguji.com" + hashLocation;
    this.$matomo.setCustomUrl(url); //覆盖页面报告的url，可以自定义页面url，加上本页面路由
    //   this.$matomo.trackEvent(shopCode,hashLocation);//事件
    // this.$matomo.trackPageView(hashLocation);//页面名称,可以自定义页面名称
  },
  mounted() {
  },
  methods: {
    back() {
      this.$router.back(-1);
    },
    pushside(num){
      let parents = [];
      // console.log(num)
      // console.log('level:'+this.ancientArr.level)
      let newArr = this.ancientArr
      if(this.ancientArr.level == 3){
        // console.log('level:3;num:'+num)
        if(num == 1){
          newArr.level = 1
        }else if(num == 2){
          newArr.level = 2
        }else if(num == 3){
          newArr.level = 3
        }
      }else if(this.ancientArr.level == 2){
        // console.log('level:2;num:'+num)
        if(num == 2){
          newArr.level = 1
        }else if(num == 3){
          newArr.level = 2
        }
      }else if(this.ancientArr.level == 1){
        // console.log('level:1;num:'+num)
        if(num == 3){
          newArr.level = 1
        }
      }
      parents.push(
        newArr.id,
        newArr.pid,
        newArr.ppid,
        newArr.category_name,
        newArr.p_category_name,
        newArr.pp_category_name,
        newArr.level
      );
        this.parents = parents;
    },
    // 获取side组件传递过来的category_id值
    getCategoryId(msg) {
      // console.log(msg)
      //category_id: 分类编号（最近一层分类）
      // datas.push(id,pid,ppid,category_name,p_category_name,pp_category_name,level)
      this.ancientArr = {
        id:msg[0],
        pid:msg[1],
        ppid:msg[2],
        category_name:msg[3],
        p_category_name:msg[4],
        pp_category_name:msg[5],
        level:msg[6]
      }
      if(this.ancientArr.level == 1){
        this.current_category_id = msg[2]
        this.pp_category_name = null;
        this.p_category_name = null;
        this.category_name = msg[5];
      }else if(this.ancientArr.level == 2){
        this.current_category_id = msg[1]
        this.pp_category_name = null;
        this.p_category_name = msg[5];
        this.category_name = msg[4];
      }else if(this.ancientArr.level == 3){
        this.current_category_id = msg[0]
        this.pp_category_name = msg[5];
        this.p_category_name = msg[4];
        this.category_name = msg[3];
      }

      // console.log(this.current_category_id)
      // this.current_category_id = msg[0];
      // // 等级  1：一级分类 2：二级分类 3：三级分类
      // this.level = msg[4];
      // if(this.level == 3){
      //   this.pid = msg[5]
      // }
      // console.log(1111);
      this.current_page = 1;
      this.getBooks();
    },
    getBooks() {
      let that = this;
      let datas = {
        user_id: that.$store.state.user_id,
        category_id: that.current_category_id,
        level: that.ancientArr.level,
        page: that.current_page,
        page_size: that.page_size
      };
      // console.log(datas)
      that.$axios
        .get("books", {
          params: datas
        })
        .then(res => {
          // console.log(res.data)
          if (res.data.status_code == 200) {
            that.books = res.data.data.books;
            for (var i = 0; i < that.books.length; i++) {
              var a = parseInt(5 * Math.random());
              that.books[i]["background"] = that.bgcolor[a];
            }
            that.total_pages = res.data.data.total_pages;
            that.current_page = res.data.data.current_page;
            let array = [
              this.ancientArr.id,
              this.ancientArr.pid,
              this.ancientArr.ppid,
              this.ancientArr.category_name,
              this.ancientArr.p_category_name,
              this.ancientArr.pp_category_name
            ]
            if(that.ancientArr.level==1){
              array[6] = 5
            }else if(that.ancientArr.level == 2){
              array[6] = 6
            }else if(that.ancientArr.level == 3){
              array[6] = 7
            }
            // console.log(array)
            this.parents = array;
          } else {
            return false;
          }
        })
        .catch(function(err) {
          console.log(err)
        });
    },
    // 点击前一页
    handlePre(val) {
      //val是pagination中的第几页
      // console.log(val)
      if (this.current_page > 1 && this.current_page !== val) {
        this.current_page -= 1;
        this.input_page = this.current_page;
        this.getBooks();
      }
    },
    // 点击下一页
    handleNext(val) {
      if (this.current_page < this.total_pages && this.current_page !== val) {
        this.current_page += 1;
        this.input_page = this.current_page;
        this.getBooks();
      }
    },
    changePage(val) {
      if (this.current_page !== val) {
        this.current_page = val;
        this.getBooks();
      }
    },
    // 到书详情
    toBookDetail(id) {
      this.book_id = id;
      // console.log(this.book_id)
      // this.$router.push({
      //   path: "/bookDetail",
      //   query: { book_id: this.book_id }
      // });
      let pictureUrl = this.$router.resolve({
        path: "/bookDetail",
        query: {
          book_id: this.book_id
        }
      });
      window.open(pictureUrl.href, "_blank");
    },
    showBig(id) {
      // console.log(id)
      this.showId = id;
      // console.log(this.showId)
    },
    hideBig() {
      this.showId = null;
    }
  },
  watch: {
    books() {
      this.$nextTick(function() {
        // console.log("body: "+document.body.offsetHeight)
        // console.log("window.innerHeight: "+window.innerHeight)
        // console.log("screen.height: "+screen.height)
        // window.innerHeight>document.body.clientHeight && (this.$refs.lists.style.minHeight = window.innerHeight-216 +'px')
      });
    }
  }
};
</script>

<style lang="scss" scoped="" type="text/css">
@import url("../../assets/style/app.scss");
.box_books {
  padding: 36px;
  padding-top: 30px;
  background: #fff;
  // border:1px solid red;
  .content {
    // padding: 0 35px;
    padding-left: 35px;
    box-sizing: border-box;
    // border:1px solid;
    width: 1200px;
    &::after {
      content: "";
      display: block;
      clear: both;
    }
  }
}
.right {
  width: 800px;
  background-color: #fff;
  margin-left: 79px;
  float: left;
  // border:1px solid red;
  .nav {
    margin-bottom: 30px;
    height: 20px;
  }
  .lists {
    margin-top: -40px;
    margin-bottom: 30px;
    // border:1px solid red;
    &::after {
      content: "";
      width: 240px;
      border: 1px solid transparent;
    }
    
    .list {
      width: 240px;
      text-align: center;
      line-height: 1;
      margin-top: 40px;
      display: inline-block;
      margin-right: 38px;
      .image_box {
        cursor: pointer;
        width: 240px;
        height: 173px;
        position: relative;
        &:hover {
          box-shadow: 0px 1px 11px 1px rgba(0, 0, 0, 0.07);
        }
        .book_box {
          width: 95px;
          height: 119px;
          padding-top: 30px;
          margin-left: 71px;
          position: relative;
          .book {
            width: 100%;
          }
          .shadow {
            width: 127px;
            height: 145px;
            position: absolute;
            bottom: -17px;
            left: -10px;
          }
        }
        .scale_box {
          position: absolute;
          right: -240px;
          top: 30px;
          z-index: 100;
          .book_scale {
            width: 300px;
          }
          .shadow_scale {
            width: 390px;
            position: absolute;
            bottom: -24px;
            left: -20px;
          }
        }
      }
        &:nth-child(3),
					&:nth-child(6),
					&:nth-child(9){
						margin-right: 0px;
					}
      .title {
        width: fit-content;
        margin: 0 auto;
        cursor: pointer;
        font-size: 16px;
        // font-family:FZGB10;
        font-family: PingFangSC-Medium, sans-serif;
        font-weight: 500;
        color: #333;
        margin-top: 10px;
      }
      .author,
      .remark {
        font-size: 13px;
        font-family: PingFangSC-Light, sans-serif;
        font-weight: 300;
        color: #999;
        margin-top: 11px;
      }
    }
  }

  .pagination {
    margin: 40px auto 35px;
    text-align: center;
  }
}
</style>
<style>
/* // 分页 */
.right .pagination {
  margin: 10px auto 50px;
  width: 100%;
  text-align: center;
}
.right .el-pagination.is-background .btn-next,
.right .el-pagination.is-background .btn-prev {
  /* background: linear-gradient(
    -55deg,
    rgba(255, 124, 90, 1),
    rgba(230, 82, 43, 1)
  ); */
  background: #e6522b !important;
  color: #fff;
  min-width: 50px;
  height: 36px !important;
  line-height: 34px;
  border-radius: 4px;
  margin: 0 20px;
}
.right .el-icon {
  font-size: 14px;
  color: #fff;
}
.right .el-icon:disabled {
  background: #fff;
}
.right .el-icon:disabled .el-icon {
  color: #bfbfbf;
  border: 1px solid #ddd;
  min-width: 50px;
  height: 36px;
  line-height: 36px;
  border-radius: 4px;
}
/* // 中间页码 */
.right .el-pager li {
  min-width: 38px !important;
  height: 38px !important;
  line-height: 38px !important;
  border-radius: 19px !important;
  font-size: 16px;
  border: 1px solid #ddd;
  color: #999;
  background-color: #fff !important;
  margin: 0 11px !important;
}
.right .el-pager li:hover {
  /* background: linear-gradient(
    -55deg,
    rgba(255, 124, 90, 1),
    rgba(230, 82, 43, 1)
  ); */
  background: #e6522b !important;
  color: #fff !important;
  border: 1px transparent;
  line-height: 34px;
}
.right .el-pager li.active {
  /* background: linear-gradient(
    -55deg,
    rgba(255, 124, 90, 1),
    rgba(230, 82, 43, 1)
  ); */
  background: #e6522b !important;
  color: #fff !important;
  line-height: 34px;
  border: 1px transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/page/ancientBooks.vue